import { Link, createFileRoute } from '@tanstack/react-router'

export const Route = createFileRoute('/checkout/cancel')({
  component: CheckoutCancel,
})

function CheckoutCancel() {
  return (
    <div className="min-h-screen flex items-center justify-center p-5">
      <div
        className="rounded-2xl p-12 text-center max-w-lg w-full"
        style={{ background: 'rgba(255,255,255,0.02)', border: '1px solid rgba(0,191,255,0.08)' }}
      >
        <div
          className="w-20 h-20 rounded-full flex items-center justify-center mx-auto mb-6"
          style={{ background: 'rgba(0, 191, 255,0.1)', border: '1px solid rgba(0, 191, 255,0.25)' }}
        >
          <svg width="36" height="36" viewBox="0 0 24 24" fill="none" stroke="#00bfff" strokeWidth="2.5">
            <path d="M18 6L6 18M6 6l12 12"/>
          </svg>
        </div>
        <h1 className="font-display text-4xl tracking-wide chrome-text mb-4">CHECKOUT CANCELLED</h1>
        <p className="text-sm leading-relaxed mb-8" style={{ color: '#8ecfff' }}>
          No charges were made. Your cart is still waiting — head back to Pulse Shop whenever you're ready.
        </p>
        <div className="flex flex-col sm:flex-row gap-3 justify-center">
          <Link
            to="/shop"
            className="btn-primary px-6 py-3 rounded-xl text-sm font-semibold"
          >
            Return to Shop
          </Link>
          <Link
            to="/"
            className="btn-chrome px-6 py-3 rounded-xl text-sm"
          >
            Go Home
          </Link>
        </div>
      </div>
    </div>
  )
}
